<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-cloud-upload title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.subscriptions' | transloco}}</p>
        <p>{{'menu.descriptions.subscriptions' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.delete' | transloco"
                [disabled]="selected.length == 0"
                (click)="confirmAndDeleteSelected()"
                pButton
                pRipple
                class="p-button-danger mb-2 sm:mb-0"
                icon="pi pi-trash"
              ></button>
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(first)]="first"
          [(rows)]="rows"
          [(selection)]="selected"
          [value]="subscriptions"
          [totalRecords]="totalSubscriptions"
          [responsive]="true"
          [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          sortField="name"
          dataKey="dataKey"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width"></th>
              <th class="selection-column-width"></th>
              <th pSortableColumn="active">
                {{'attribute.state' | transloco}}<p-sortIcon field="active"></p-sortIcon></th>
              <th pSortableColumn="name">
                {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
              <th pSortableColumn="description">
                {{'attribute.description' | transloco}}<p-sortIcon field="description"></p-sortIcon></th>
              <th pSortableColumn="tenant" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'attribute.tenant' | transloco}}<p-sortIcon field="tenant"></p-sortIcon></th>
              <th pSortableColumn="subscriptionType">
                {{'attribute.subscriptionType' | transloco}}<p-sortIcon field="subscriptionType"></p-sortIcon></th>
              <th pSortableColumn="protocol">
                {{'attribute.protocol' | transloco}}<p-sortIcon field="protocol"></p-sortIcon></th>
              <th class="w-10rem">
                {{'common.actions' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-subscription let-expanded="expanded">
            <tr *ngIf="!loadingSubscriptions" class="fadein">
              <td>
                <span class="p-column-title bold">{{'common.expand' | transloco}}</span>
                <div class="flex flex-row align-items-center gap-4">
                  <button
                    [pRowToggler]="subscription"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    pButton
                    pRipple
                    class="p-button-text p-button-rounded p-button-plain"
                    type="button"
                  ></button>
                </div>
              </td>
              <td>
                <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                <p-tableCheckbox [value]="subscription"></p-tableCheckbox>
              </td>
              <td>
                <span class="p-column-title bold">{{'applications.subscriptions.enabled' | transloco}}</span>
                <p-tag *ngIf="subscription.active">{{'applications.subscriptions.enabled' | transloco | uppercase}}</p-tag>
                <p-tag *ngIf="!subscription.active" severity="danger">{{'applications.subscriptions.disabled' | transloco | uppercase}}</p-tag>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                <p class="text-right md:text-left">{{subscription.name}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                <p class="text-right md:text-left">{{subscription.description}}</p>
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'attribute.tenant' | transloco}}</span>
                <a *ngIf="subscription.tenant" [routerLink]="['/management/tenants', subscription.tenant.uuid, 'details']">
                  {{subscription.tenant.name}}
                </a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.subscriptionType' | transloco}}</span>
                <p-tag
                  [value]="subscription.subscriptionType"
                  [styleClass]="
                    subscription.subscriptionType === 'MEASUREMENTS' ? 'tag-measurements' :
                    subscription.subscriptionType === 'PROPERTIES' ? 'tag-properties' :
                    subscription.subscriptionType === 'EVENTS' ? 'tag-events' :
                    subscription.subscriptionType === 'COMPLEX_EVENTS' ? 'tag-complex-events' :
                    subscription.subscriptionType === 'ALL' ? 'tag-all' : ''
                  ">
                </p-tag>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.protocol' | transloco}}</span>
                <p class="text-right md:text-left">{{subscription.protocol}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-end">
                  <button
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    [icon]="subscription.active ? 'pi pi-pause' : 'pi pi-play'"
                    (click)="toggleSubscription(subscription)"
                  ></button>
                  <button
                    [routerLink]="subscription.tenant.uuid + '/' + subscription.name + '/edit'"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    (click)="confirmAndDelete(subscription)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingSubscriptions" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-subscription>
            <tr>
              <td colspan="8">
                <div class="grid">
                  <div class="col-6">
                    <b>{{'attribute.appliedTo' | transloco}}:</b>
                  </div>
                  <div class="col-6">
                    <b>{{'attribute.protocolConfig' | transloco}}:</b>
                  </div>
                  <div class="col-6">
                    <ngx-json-viewer *ngIf="subscription.appliedTo" [json]="subscription.appliedTo"></ngx-json-viewer>
                    <div *ngIf="!subscription.appliedTo"><i>{{'empty.appliedTo' | transloco}}</i></div>
                  </div>
                  <div class="col-6">
                    <ngx-json-viewer *ngIf="subscription.protocolConfig" [json]="subscription.protocolConfig"></ngx-json-viewer>
                    <div *ngIf="!subscription.protocolConfig"><i>{{'empty.protocolConfig' | transloco}}</i></div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalSubscriptions == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalSubscriptions > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalSubscriptions ? totalSubscriptions : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalSubscriptions}}
              {{(totalSubscriptions > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>

    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          appAutoFocus
          class="w-full"
          id="name"
          type="text"
        >
      </div>
    </div>

    <div class="col-12">
      <div class="col-12 form-field">
        <label for="exchange">{{'attribute.description' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.description"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          class="w-full"
          id="exchange"
          type="text"
        >
      </div>
    </div>

    <div class="col-12">
      <div class="col-12 form-field">
        <label for="exchange">{{'attribute.subscriptionType' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-dropdown
          [(ngModel)]="currentFilters.subscriptionType"
          [placeholder]="'select.subscriptionType' | transloco"
          [options]="subscriptionTypes"
          [showClear]="true"
          [autoDisplayFirst]="false"
          styleClass="w-full"
          id="subscriptionType"
          appendTo="body"
        ></p-dropdown>
      </div>
    </div>

    <div class="col-12">
      <div class="col-12 form-field">
        <label for="exchange">{{'attribute.protocol' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-dropdown
          [(ngModel)]="currentFilters.protocol"
          [placeholder]="'select.protocol' | transloco"
          [options]="protocols"
          [showClear]="true"
          [autoDisplayFirst]="false"
          styleClass="w-full"
          id="protocol"
          appendTo="body"
        ></p-dropdown>
      </div>
    </div>

    <div class="col-12" *ngIf="authGuardService.superAdminRequired()">
      <div class="col-12 form-field">
        <label for="tenant">{{'model.tenant' | transloco}}</label>
      </div>
      <div class="col-12">
        <p-multiSelect
          [(ngModel)]="currentFilters.tenantUuids"
          [placeholder]="'select.generic' | transloco"
          [options]="tenants"
          [filter]="true"
          styleClass="w-full"
          id="tenant"
          optionLabel="name"
          optionValue="uuid"
          filterBy="name"
          display="chip"
          appendTo="body"
        ></p-multiSelect>
      </div>
    </div>

    <div class="col-12">
      <div class="col-12 form-field">
        <label for="active">{{'attribute.state' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-dropdown
          [(ngModel)]="currentFilters.active"
          [placeholder]="'select.status' | transloco"
          [options]="activeOptions"
          [showClear]="true"
          [autoDisplayFirst]="false"
          styleClass="w-full"
          id="active"
          appendTo="body"
        >
          <ng-template let-item pTemplate="selectedItem">
            {{ item.label | transloco }}
          </ng-template>
          <ng-template let-item pTemplate>
            {{ item.label | transloco }}
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
          currentFilters.name ||
          currentFilters.description ||
          currentFilters.subscriptionType ||
          currentFilters.protocol ||
          currentFilters.tenantUuids ||
          currentFilters.active != null
        )"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false;"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>

  </div>
</p-sidebar>
